import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { Productos } from '../models/Productos';

export class ProductoService {
  
  // Obtener todos los productos con soporte de imágenes
  static async getAllPr(id, incluirImagen = true) {
    try {
      console.log('🔍 === GETALLPRODUCTOS DEBUG ===');
      console.log('🔍 URL:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.PRODUCTO);
      console.log('🔍 Sucursal ID:', id);
      console.log('🔍 Incluir imagen:', incluirImagen);
      
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/sucursal/${id}?incluirImagen=${incluirImagen}`
      );
      
      console.log('✅ Respuesta cruda del API:', response.data);
      console.log('✅ Tipo de response.data:', typeof response.data);
      console.log('✅ Keys de response.data:', Object.keys(response.data));
      
      // Manejo específico para el formato de API
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data; // Formato: {success: true, data: [...]}
        console.log('✅ Usando response.data.data (formato success/data)');
      } else if (Array.isArray(response.data)) {
        Data = response.data; // Formato directo: [...]
        console.log('✅ Usando response.data (formato array directo)');
      } else {
        console.error('❌ Formato de API no reconocido:', response.data);
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      console.log('✅ Datos extraídos:', Data);
      console.log('✅ Es array?', Array.isArray(Data));
      console.log('✅ Cantidad de elementos:', Data.length);
      
      if (!Array.isArray(Data)) {
        console.error('❌ Data no es array:', Data);
        throw new Error('Los datos recibidos no son un array');
      }
      
      // Mapear cada producto y mostrar debug
      const mapped = Data.map((productData, index) => {
        console.log(`🔍 Mapeando producto ${index}:`, productData);
        
        // Crear instancia de Productos
        const producto = new Productos(productData);
        
        console.log(`✅ Producto mapeado ${index}:`, producto.toDebug());
        
        // Debug específico para imagen
        if (producto.Imagen) {
          console.log(`🖼️ Producto ${index} tiene imagen de ${producto.Imagen.length} caracteres`);
        } else {
          console.log(`🖼️ Producto ${index} no tiene imagen`);
        }
        
        return producto;
      });
      
      console.log('✅ TODOS LOS PRODUCTOS MAPEADOS:', mapped.length);
      return mapped;
      
    } catch (error) {
      console.error('❌ === ERROR GETALLPRODUCTOS ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Status Text:', error.response.statusText);
        console.error('❌ Data:', error.response.data);
        console.error('❌ Headers:', error.response.headers);
      }
      
      throw new Error('Error al obtener Productos: ' + error.message);
    }
  }

  // Obtener producto por ID
  static async getById(id, incluirImagen = true) {
    try {
      console.log('🔍 Obteniendo producto ID:', id);
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/${id}?incluirImagen=${incluirImagen}`
      );
      console.log('✅ Producto obtenido:', response.data);
      
      const productData = response.data.data || response.data;
      return new Productos(productData);
    } catch (error) {
      console.error('❌ Error obteniendo Producto:', error);
      throw new Error('Error al obtener el Producto');
    }
  }

  // 🔧 CREAR PRODUCTO - MÉTODO CORREGIDO
  static async create(Data) {
    try {
      console.log('🔍 === CREATE PRODUCTO DEBUG ===');
      console.log('🔍 Data recibido:', Data);
      
      let producto;
      if (Data instanceof Productos) {
        producto = Data;
      } else {
        producto = new Productos(Data);
      }
      
      console.log('🔍 Producto instance:', producto.toDebug());
      
      // ✅ USAR FORMDATA PARA CREAR PRODUCTOS
      const formData = new FormData();
      
      // Campos básicos (SIN incluir id_producto para crear)
      formData.append('nombre_producto', producto.Nombre_producto || '');
      formData.append('descripcion', producto.Descripcion || '');
      formData.append('precio', parseFloat(producto.Precio) || 0);
      formData.append('estado', producto.Estado || 'ACTIVO');
      formData.append('id_categoria', parseInt(producto.Id_categoria) || 0);
      formData.append('id_sucursal', parseInt(producto.Id_sucursal) || 0);
      
      // ✅ MANEJAR LA IMAGEN CORRECTAMENTE - SOLO imagenFile
      if (producto.Imagen && producto.Imagen.length > 0) {
        console.log('🖼️ Creando producto con imagen - tamaño base64:', producto.Imagen.length);
        
        try {
          // Convertir base64 a Blob
          const base64Data = producto.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          // ✅ ENVIAR SOLO COMO imagenFile - NO enviar campo 'imagen'
          formData.append('imagenFile', blob, 'producto.jpg');
          console.log('✅ Imagen agregada al FormData SOLO como imagenFile');
          
        } catch (imageError) {
          console.error('❌ Error procesando imagen para creación:', imageError);
          throw new Error('Error al procesar la imagen');
        }
      } else {
        console.log('📝 Creando producto sin imagen');
      }
      
      // Debug del FormData final
      console.log('🔍 === FormData FINAL para CREATE ===');
      for (let pair of formData.entries()) {
        const value = pair[1] instanceof Blob ? `[BLOB: ${pair[1].size} bytes]` : pair[1];
        console.log(`  ${pair[0]}: ${value}`);
      }
      
      const response = await apiClient.post(
        API_CONFIG.ENDPOINTS.PRODUCTO,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      
      console.log('✅ Producto creado exitosamente:', response.data);
      
      const createdData = response.data.data || response.data;
      return new Productos(createdData);
      
    } catch (error) {
      console.error('❌ === ERROR CREANDO PRODUCTO ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response data:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      throw new Error('Error al crear el Producto: ' + (error.response?.data?.message || error.message));
    }
  }

  // 🔧 ACTUALIZAR PRODUCTO - MÉTODO CORREGIDO
  static async update(id, Data) {
    try {
      console.log('🔍 === UPDATE PRODUCTO DEBUG ===');
      console.log('🔍 URL ID:', id);
      
      if (!id) {
        throw new Error('ID de Producto no proporcionado');
      }
      
      let producto;
      if (Data instanceof Productos) {
        producto = Data;
      } else {
        producto = new Productos(Data);
      }
      
      console.log('🔍 Producto.Id_producto:', producto.Id_producto);
      console.log('🔍 Producto a actualizar:', producto.toDebug());
      
      // ✅ USAR FORMDATA PARA ACTUALIZAR PRODUCTOS
      const formData = new FormData();
      
      // ✅ INCLUIR ID EN FORMDATA - EL API LO VALIDA CONTRA LA URL
      // Campos básicos (incluyendo id_producto para validación)
      formData.append('id_producto', id); // Usar el ID de la URL
      formData.append('nombre_producto', producto.Nombre_producto || '');
      formData.append('descripcion', producto.Descripcion || '');
      formData.append('precio', parseFloat(producto.Precio) || 0);
      formData.append('estado', producto.Estado || 'ACTIVO');
      formData.append('id_categoria', parseInt(producto.Id_categoria) || 0);
      formData.append('id_sucursal', parseInt(producto.Id_sucursal) || 0);
      
      // ✅ MANEJAR LA IMAGEN CORRECTAMENTE - SOLO imagenFile
      if (producto.Imagen && producto.Imagen.length > 0) {
        console.log('🖼️ Actualizando con imagen - tamaño base64:', producto.Imagen.length);
        
        try {
          // Convertir base64 a Blob
          const base64Data = producto.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          // ✅ ENVIAR SOLO COMO imagenFile - NO enviar campo 'imagen'
          formData.append('imagenFile', blob, 'producto.jpg');
          console.log('✅ Imagen agregada al FormData SOLO como imagenFile');
          
        } catch (imageError) {
          console.error('❌ Error procesando imagen para actualización:', imageError);
          throw new Error('Error al procesar la imagen para actualización');
        }
      } else {
        console.log('📝 Actualizando sin imagen nueva');
      }
      
      // Debug del FormData final
      console.log('🔍 === FormData FINAL para UPDATE ===');
      for (let pair of formData.entries()) {
        const value = pair[1] instanceof Blob ? `[BLOB: ${pair[1].size} bytes]` : pair[1];
        console.log(`  ${pair[0]}: ${value}`);
      }
      console.log('🔍 URL final:', `${API_CONFIG.ENDPOINTS.PRODUCTO}/${id}`);
      
      const response = await apiClient.put(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/${id}`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      
      console.log('✅ Producto actualizado exitosamente:', response.data);
      const updatedData = response.data.data || response.data;
      return new Productos(updatedData);
      
    } catch (error) {
      console.error('❌ === ERROR ACTUALIZANDO PRODUCTO ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response data:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      throw new Error('Error al actualizar el Producto: ' + (error.response?.data?.message || error.message));
    }
  }

  // Eliminar producto
  static async deleteRole(id) {
    try {
      console.log('🔍 Eliminando Producto ID:', id);
      await apiClient.delete(`${API_CONFIG.ENDPOINTS.PRODUCTO}/${id}`);
      console.log('✅ Producto eliminado exitosamente');
      return true;
    } catch (error) {
      console.error('❌ Error eliminando Producto:', error);
      console.error('❌ Error response:', error.response?.data);
      throw new Error('Error al eliminar el Producto: ' + (error.response?.data?.message || error.message));
    }
  }

  // Subir imagen por separado (opcional - para casos especiales)
  static async uploadImage(productId, imageFile) {
    try {
      console.log('🔍 === UPLOAD IMAGE DEBUG ===');
      console.log('🔍 Product ID:', productId);
      console.log('🔍 Image File:', imageFile);
      
      const formData = new FormData();
      formData.append('imagenFile', imageFile); // ✅ Usar imagenFile en lugar de imagen
      
      const response = await apiClient.post(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/${productId}/imagen`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      
      console.log('✅ Imagen subida:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('❌ Error subiendo imagen:', error);
      console.error('❌ Error response:', error.response?.data);
      throw new Error('Error al subir la imagen: ' + (error.response?.data?.message || error.message));
    }
  }

  // Obtener imagen por ID (opcional - para casos especiales)
  static async getImage(productId) {
    try {
      console.log('🔍 Obteniendo imagen del producto ID:', productId);
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/${productId}/imagen`,
        {
          responseType: 'blob'
        }
      );
      
      // Convertir blob a data URL
      const blob = response.data;
      const reader = new FileReader();
      
      return new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      
    } catch (error) {
      console.error('❌ Error obteniendo imagen:', error);
      throw new Error('Error al obtener la imagen');
    }
  }

  // Obtener productos por categoría
  static async getByCategoria(categoriaId, sucursalId, incluirImagen = true) {
    try {
      console.log('🔍 Obteniendo productos por categoría:', categoriaId, 'sucursal:', sucursalId);
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/categoria/${categoriaId}/sucursal/${sucursalId}?incluirImagen=${incluirImagen}`
      );
      
      const Data = response.data.data || response.data;
      
      if (!Array.isArray(Data)) {
        throw new Error('Los datos recibidos no son un array');
      }
      
      return Data.map(productData => new Productos(productData));
      
    } catch (error) {
      console.error('❌ Error obteniendo productos por categoría:', error);
      throw new Error('Error al obtener productos por categoría');
    }
  }

  // Buscar productos
  static async search(searchTerm, sucursalId, incluirImagen = true) {
    try {
      console.log('🔍 Buscando productos:', searchTerm, 'en sucursal:', sucursalId);
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PRODUCTO}/search?q=${encodeURIComponent(searchTerm)}&sucursal=${sucursalId}&incluirImagen=${incluirImagen}`
      );
      
      const Data = response.data.data || response.data;
      
      if (!Array.isArray(Data)) {
        throw new Error('Los datos recibidos no son un array');
      }
      
      return Data.map(productData => new Productos(productData));
      
    } catch (error) {
      console.error('❌ Error buscando productos:', error);
      throw new Error('Error al buscar productos');
    }
  }

  // Validar imagen antes de enviar
  static validateImage(imageData) {
    if (!imageData) return true; // Opcional
    
    try {
      // Si es base64, verificar que tenga el formato correcto
      if (typeof imageData === 'string') {
        // Remover prefijo data: si existe
        const base64Data = imageData.replace(/^data:image\/[a-z]+;base64,/, '');
        
        // Verificar que sea base64 válido
        const decoded = atob(base64Data);
        
        // Verificar tamaño aproximado (5MB máximo)
        if (decoded.length > 5 * 1024 * 1024) {
          throw new Error('La imagen es demasiado grande (máximo 5MB)');
        }
        
        return true;
      }
      
      return true;
    } catch (error) {
      console.error('❌ Error validando imagen:', error);
      return false;
    }
  }

  // Comprimir imagen base64 (opcional)
  static compressBase64Image(base64Data, quality = 0.7) {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        // Calcular nuevas dimensiones manteniendo ratio
        const maxWidth = 800;
        const maxHeight = 600;
        let { width, height } = img;
        
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
        
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Dibujar imagen redimensionada
        ctx.drawImage(img, 0, 0, width, height);
        
        // Convertir a base64 comprimido
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedBase64.split(',')[1]); // Remover prefijo
      };
      
      img.src = `data:image/jpeg;base64,${base64Data}`;
    });
  }

  // MÉTODO DE PRUEBA
  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION ===');
      console.log('🧪 URL Base:', API_CONFIG.BASE_URL);
      console.log('🧪 Endpoint:', API_CONFIG.ENDPOINTS.PRODUCTO);
      console.log('🧪 URL Completa:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.PRODUCTO);
      
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.PRODUCTO);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      console.log('✅ Response completo:', response);
      console.log('✅ Response data:', response.data);
      
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      console.error('❌ Error response:', error.response);
      return error;
    }
  }
}